import styled from 'styled-components';
import Link from 'next/link';
// styles
import { palette, mediaQuery } from 'cds/styles';
import * as typography from 'cds/typography';

/**
 * 기획전 이동 버튼
 * @param {object} props
 * @param {string} props.href 기획전 url
 * @param {string} props.imageURL 기획전 이미지 URL
 * @param {string} props.bgColor 배경 색상
 */
const PlanButton = ({ href, imageURL, bgColor, target }) => {
  if (target) {
    return (
      <Item bgColor={bgColor}>
        <Link href={href} passHref>
          <Content url={imageURL} target="_blank" rel="noopener noreferrer" />
        </Link>
      </Item>
    );
  }

  return (
    <Item bgColor={bgColor}>
      <Link href={href} passHref>
        <Content url={imageURL}></Content>
      </Link>
    </Item>
  );
};

const Item = styled.li`
  overflow: hidden;
  position: relative;
  padding-bottom: 20%;
  border-radius: 8px;
  background-color: ${({ bgColor }) => bgColor};

  & ~ & {
    margin-top: 12px;
  }

  ${mediaQuery.medium} {
    & ~ & {
      margin-top: 0;
    }
  }
`;

const Content = styled.a`
  display: flex;
  position: absolute;
  align-items: center;
  flex: 0 auto;
  width: 100%;
  height: 100%;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  padding: 0 40px;
  background-color: transparent;
  background-image: ${({ url }) => `url(${url})`};
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  ${typography.subtitle3_medium}
  color: ${palette.white};

  ${mediaQuery.large} {
    font-size: 16px;
  }

  ${mediaQuery.xlarge} {
    font-size: 20px;
  }
`;

export default PlanButton;
